/*
 * @Author: zhangmh31513
 * @Date: 2021-09-07 09:15:17
 * @LastEditTime: 2021-11-15 13:40:55
 * @LastEditors: zhangmh31513
 * @Description:
 * @FilePath: \openplat-web\src\gtn\api\developerConference.js
 * 有问题请第一时间来联系我
 */
import fetch from "./httpFetch.js";
const modelName = "/openplat-developer-server/v/";
/***提交申请单***/
export function showTicket() {
  return fetch.get(modelName + "show_ticket");
}
/***验证优惠码***/
export function checkCoupon(params) {
  return fetch.post(modelName + "check_coupon", params);
}
/***添加门票***/
export function addGoods(params) {
  return fetch.post(modelName + "add_order", params);
}
/***查询支付状态***/
export function getPayStatus(data) {
  return fetch.get(modelName + "get_pay_status?tickets_id=" + data);
}
/***查询二维码***/
export function getPayInfo(data) {
  return fetch.get(modelName + "get_pay_info?tickets_id=" + data);
}
/***查询分会场***/
export function searchAreaList() {
  return fetch.get(modelName + "search_area_list");
}
/***查询购票人邮箱***/
export function getBuyerInfo(data) {
  return fetch.get(modelName + "get_buyer_info?tickets_id=" + data);
}
/***添加合作伙伴***/
export function addPartner(params) {
  return fetch.post(modelName + "add_partner", params);
}
/***查询是否已申请合作伙伴***/
export function getPartners() {
  // return fetch.get(modelName + "get_partners");
  return fetch.get(modelName + "get_partner");
}
/***预约观看***/
export function subscribe() {
  return fetch.post(modelName + "subscribe");
}
/***验证是否登陆***/
export function checkLogin() {
  return fetch.get(modelName + "check_login");
}
/***同期活动验证是否报名***/
export function check_activity_signup() {
  return fetch.get(modelName + "check_activity_signup");
}
/***同期活动报名***/
export function activity_signup(params) {
  return fetch.post(modelName + "activity_signup", params);
}
/* 获取报名截止时间 */
export function get_signup_end_time() {
  return fetch.get(modelName + "get_signup_end_time");
}

/* 线上版本预约论坛报名 */
export function onlineSignup(params) {
  return fetch.post(modelName + "online_signup", { ...params })
}
/* 查询用户是否报名 */
export function checkOnlineSignup() {
  return fetch.get(modelName + "check_online_signup")
}
/* 光子任务,参数是task_id，task_type*/
export function completePhotonTask(params) {
  return fetch.post(modelName + "completePhotonTask", { ...params })
}
// 查询行业
export function getIndustryList() {
  return fetch.get(modelName + "get_industry_list")
}
/**
 * @description 查询当前论坛直播状态
 * @param  {} params area_id 论坛ID
 * @param  {} {returnfetch.get(modelName+"get_live_info"
 */
export function getLiveInfo(params) {
  return fetch.get(modelName + `get_live_info?area_id=${params}`)
}



// WEBPACK FOOTER //
// ./src/gtn/api/developerConference.js